import { AuthUserType } from "../../../auth/types";

// Define which items are enabled for the "patient" role
const PATIENT_ALLOWED_ITEMS = ["diary", "patient"];

/**
 * Adjust navigation configuration based on user role
 * - Keeps all items visible
 * - Marks disallowed ones as disabled instead of removing them
 */
export const filterNavByRole = (navConfig: any[], user: AuthUserType) => {
  // If no user or role, return all as-is
  if (!user || !user.roleId) {
    return navConfig;
  }

  // If user is a patient
  if (user.roleId === "patient") {
    return navConfig.map((section) => ({
      ...section,
      items: section.items.map((item: any) => ({
        ...item,
        // Disable items not in allowed list
        disabled: !PATIENT_ALLOWED_ITEMS.includes(item.title.toLowerCase()),
      })),
    }));
  }

  // For all other roles, no restrictions
  return navConfig;
};
